import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import InputBox from "../../../common/interactive/InputBox"
import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import SOSDetails from "./SOSDetails"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { getCaseIdFromCasePayload } from "../../../../lib/caseUpdateHelpers"
import { notificationActions } from "../../../../store/notifications"
import CheckboxCell from "../../../common/interactive/CheckboxCell"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import GeneratePDFDownload from "../Shared/GeneratePDFDownload"
import { sosFunctions } from "../../../../lib/sos"
import Button from "../../../common/Button"
import AddSosModal from "./AddSosModal"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import classes from "./SOSTab.module.css"

const SOSTab = ({ inWorkQ }) => {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const sosEditDisabled = useUserTabEditPermissionDisabled('case_sos')
    const [showAddSosModal, setShowAddSosModal] = useState(false) 

    const updateHandler = async (data) => {           
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let dispatchObj = {
            folder: data.identifier.folder, //'crime_victim',
            item: {
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }

        if (data.identifier.field == 'sos_paid') {
            reqBody.fields.sos_paid_amount = null
            dispatchObj.item.fields.push({
                field: 'sos_paid_amount',
                value: null
            })
        }
        dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))

        const caseId = getCaseIdFromCasePayload(activeCase)
        if (caseId == null) {
            dispatch(notificationActions.setError({ errorMessage: 'Case is not available to save changes.', type: 'error' }))
            return
        }
        let update = await caseQuickUpdate(userToken, caseId, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
        }        
        
    }

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>SOS</h2>
                <NotesComponent noteTypeId={6} inWorkQ={inWorkQ}/>
                {!sosEditDisabled && (
                    <div className={classes.add_sos_button}>
                        <Button click={() => setShowAddSosModal(true)} isDisabled={!activeCase?.case?.id}>
                            <i className="ti ti-square-plus"></i>
                            Add SOS
                        </Button>
                    </div>
                )}
            </div>
            <div className="flex-container">
                <CheckboxCell label={'Paid'} checked={activeCase?.additional?.sos_paid} action={updateHandler} identifier={{type: 'case_additional', field: 'sos_paid', type_id: null, folder: 'additional'}}/>
                {activeCase?.additional?.sos_paid ? 
                <InputBoxCurrency label={'Paid Amount'} currentValue={activeCase.additional.sos_paid_amount} action={updateHandler} identifier={{type: 'case_additional', field: 'sos_paid_amount', type_id: null, folder: 'additional'}} setStyle={'border_primary_15'} fullBox={true}/>
                :
                <></>}
                <InputBox label={'SOS Reference Number'} currentValue={activeCase?.additional?.sos_reference_number} action={updateHandler} identifier={{type: 'case_additional', field: 'sos_reference_number', type_id: null, folder: 'additional'}} setStyle={'border_primary_15'}/>
                {/* <InputBox label={'SOS Chart Number'} currentValue={activeCase.additional.sos_chart_number} isNotModifiable={true} identifier={{type: 'case_additional', field: 'sos_chart_number', type_id: null, folder: 'additional'}} setStyle={'border_primary_15'}/> */}
                <InputBox label={'SOS Chart Number'} currentValue={sosFunctions.getSosChartNumberFromPractices(activeCase?.practices)} isNotModifiable={true} identifier={{type: null, field: 'sos_chart_number', type_id: null, folder: null}} setStyle={'border_primary_15'}/>
                <GeneratePDFDownload url={{slug: 'sos_agreement', type: 'case_sos', typeID: null}} boxStyle={'btn_grey'} fileName={'sos_agreement.pdf'} variant={true}>
                    <i className="ti ti-printer"></i> Agreement
                </GeneratePDFDownload>
            </div>
        </TabHeader>
        <div>
            <SOSDetails />
        </div>
        {showAddSosModal && !sosEditDisabled && <AddSosModal closeModal={() => setShowAddSosModal(false)} />}
    </>
}

export default SOSTab